import { render, staticRenderFns } from "./PurchaseRequestCreate.vue?vue&type=template&id=455a5116&scoped=true&"
import script from "./PurchaseRequestCreate.vue?vue&type=script&lang=js&"
export * from "./PurchaseRequestCreate.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseRequestCreate.vue?vue&type=style&index=0&id=455a5116&prod&lang=scss&scoped=true&"
import style1 from "./PurchaseRequestCreate.vue?vue&type=style&index=1&id=455a5116&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455a5116",
  null
  
)

export default component.exports